// BudgetTable.js
import React, { useMemo } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatCurrency, moveToIndex, rowType } from "../helpers";

export default function BudgetTable({ rows = [], ChangeText, selectedChange }) {
  const data = useMemo(() => {
    const arr = Array.isArray(rows)
      ? rows.filter(
          (row) =>
            row.row_type !== rowType.revenue &&
            row.row_type !== rowType.approvedBudget &&
            row.row_type !== rowType.selfContribution,
        )
      : [];
    if (arr.length > 0) {
      moveToIndex(arr, 0, (x) => x.row_type === rowType.total);
      moveToIndex(arr, 1, (x) => x.row_type === rowType.staffCost);
    }
    return arr;
  }, [rows]);
  const revenue = rows.find((row) => row.row_type === rowType.revenue);

  if (data.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No budget data.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        overflowX: "auto",
        borderRadius: 2,
        border: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <Table size="small" aria-label="Budget table">
        <TableHead>
          <TableRow sx={{ bgcolor: (t) => t.palette.action.hover }}>
            <TableCell>Name</TableCell>
            <TableCell align="right">Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, idx) => (
            <TableRow
              key={idx}
              hover
              sx={{
                "&:nth-of-type(even)": {
                  bgcolor: (t) => t.palette.action.focus,
                },
              }}
            >
              <TableCell sx={{ whiteSpace: "wrap" }}>
                {selectedChange ? (
                  <ChangeText
                    newValue={row.name.new}
                    oldValue={row.name.old}
                  ></ChangeText>
                ) : (
                  row.name
                )}
              </TableCell>
              <TableCell align="right">
                {selectedChange ? (
                  <ChangeText
                    newValue={formatCurrency(row.value.new)}
                    oldValue={formatCurrency(row.value.old)}
                  ></ChangeText>
                ) : (
                  row.value_display
                )}
              </TableCell>
            </TableRow>
          ))}
          <TableRow
            key="ebs"
            hover
            sx={{ bgcolor: (t) => t.palette.action.hover }}
          >
            <TableCell sx={{ whiteSpace: "wrap" }}>{revenue.name}</TableCell>
            <TableCell align="right">
              {selectedChange ? (
                <ChangeText
                  newValue={formatCurrency(
                    data.reduce((acc, row, i) => {
                      const n = parseFloat(row.value.new);
                      const v = isNaN(n) ? 0 : n;
                      return i === 0 ? v : acc - v; // first element sets the initial value
                    }, 0) ?? 0,
                  )}
                  oldValue={formatCurrency(
                    data.reduce((acc, row, i) => {
                      const n = parseFloat(row.value.old);
                      const v = isNaN(n) ? 0 : n;
                      return i === 0 ? v : acc - v; // first element sets the initial value
                    }, 0) ?? 0,
                  )}
                ></ChangeText>
              ) : (
                revenue.value_display
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
}
